<template>
  <div class="main-container">
    <div class="sub-header fixed" style="position: fixed; top: 0">
      <div class="left-back" style="line-height: 68px; padding-left: 12px">
        <img src="@/assets/boyuan_72.png" style="height: 46px; line-height: 60px; vertical-align: middle" />
        <span style="padding-left: 5px">在线考试</span>
      </div>
      <div class="right-title">
        <span>{{ examPlanInfo.planName }}</span>
      </div>
    </div>
    <div class="main-con" style="
        margin-top: 68px;
        display: flex;
        flex-direction: column;
        background-color: #efefef;
      ">
      <div class="left-menu" style="position: fixed">
        <div class="catalog-con">
          <div class="inner">
            <p class="title"><strong>答题卡</strong></p>
            <div class="item-box">
              <!-- <div
                class="item"
                v-for="catalogData in courseCatalogData"
                :key="catalogData.id"
              >
                <div
                  class="section"
                  :class="{ 'active-bg': $route.params.id === catalogData.id }"
                >
                  <a v-if="catalogData.type" :href="`/read/${catalogData.id}`">
                    <p class="sec_name">{{ catalogData.name }}</p>
                  </a>
                  <p v-else class="sec_name">{{ catalogData.name }}</p>
                </div>
                <ul>
                  <li
                    v-for="node in catalogData.children"
                    :key="node.id"
                    :class="{
                      'active-bg': $route.params.id === node.id,
                    }"
                  >
                    <a v-if="node.type" :href="`/read/${node.id}`">
                      <div class="articleName">
                        {{ node.name }}
                      </div>
                    </a>
                    <div v-else class="articleName">
                      {{ node.name }}
                    </div>
                  </li>
                </ul>
              </div> -->

              <div class="item" v-for="(paper, index) in testingPaperData" :key="index">
                <div class="section">
                  <p class="sec_name">{{ paper.name }}</p>
                </div>
                <ul style="display: flex; flex-wrap: wrap">
                  <li v-for="child in paper.children" :key="child.id" :class="{
                    answered: child.selecteds.length > 0,
                    active: selectedQuestionId === `question${child.id}`,
                  }">
                    <!-- <a @click="selectQuestion(child.id)"></a> -->
                    <a :href="`#question${child.id}`" @click="selectQuestion(child.id)">
                      <div class="articleName">{{ child.serialNumber }}</div>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- <div class="item">
                <div class="section">
                  <p class="sec_name">单选题</p>
                </div>
                <ul style="display: flex; flex-wrap: wrap">
                  <li v-for="item in 10" :key="item">
                    <a>
                      <div class="articleName">{{ item }}</div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="item">
                <div class="section">
                  <p class="sec_name">多选题</p>
                </div>
                <ul style="display: flex; flex-wrap: wrap">
                  <li v-for="item in 10" :key="item">
                    <a>
                      <div class="articleName">{{ item }}</div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="item">
                <div class="section">
                  <p class="sec_name">选择题</p>
                </div>
                <ul style="display: flex; flex-wrap: wrap">
                  <li v-for="item in 50" :key="item">
                    <a>
                      <div class="articleName">{{ item }}</div>
                    </a>
                  </li>
                </ul>
              </div> -->
            </div>
            <div class="bottom">
              <p style="
                  border: 1px solid rgba(28, 31, 33, 0.1);
                  background: #409eff;
                  width: 15px;
                  height: 10px;
                  margin: 0 5px;
                "></p>
              已答
              <p style="
                  border: 1px solid rgba(28, 31, 33, 0.1);
                  background: #efefef;
                  width: 15px;
                  height: 10px;
                  margin: 0 5px;
                "></p>
              未答
            </div>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="container" style="max-width: 1200px; min-width: 800px">
          <div class="center_con" style="margin-top: 45px">
            <div class="article-con">
              <!-- 试题 -->
              <questions ref="questionsChild" :questionsData="testingQuestionsData" :isExamStarted="isExamStarted"
                :zoom="zoom" @questionEvent="handleQuestionEvent" />
            </div>
          </div>
        </div>
      </div>
      <div class="right-toolbar">
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <span>考生姓名</span>
          <p style="color: #3a8ee6">{{ this.$store.getters["user/name"] }}</p>
        </div>
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <span>考生班级</span>
          <p style="color: #3a8ee6">
            {{ this.$store.getters["user/classesName"] }}
          </p>
        </div>
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <span>当前时间</span>
          <p style="color: #3a8ee6">
            {{
              this.currentSystemDateText === undefined
                ? "-"
                : this.currentSystemDateText
            }}
          </p>
        </div>
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <span>开始时间</span>
          <p style="color: #3a8ee6">
            {{
              new Date(this.startDate)
              | parseTime("{h}:{i}:{s}")
            }}
          </p>
        </div>
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <template v-if="!stop">
            <span>剩余时间：</span>
            <p style="color: #3a8ee6">暂未开启</p>
          </template>
          <template v-else>
            <el-statistic ref="statistic" @finish="systemSubmit" format="HH:mm:ss" :value="countdown" title="剩余时间："
              :time-indices="stop"></el-statistic>
          </template>
        </div>

        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
            display: none;
          ">
          <span>进度条</span>
          <el-progress :text-inside="true" :stroke-width="18" :percentage="10" status="success"></el-progress>
        </div>
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <span style="margin-bottom: 4px; color: #606266; font-size: 13px">调整字体大小</span>
          <el-button-group>
            <el-button type="primary" size="mini" @click="toZoom('-')">-</el-button>
            <el-button size="mini" style="padding: 7px">
              {{ `${this.zoom}%` }}
            </el-button>
            <el-button type="primary" size="mini" @click="toZoom('+')">+</el-button>
          </el-button-group>
        </div>
        <div style="
            padding: 10px;
            border-bottom: 1px solid #efefef;
            text-align: center;
          ">
          <el-button type="primary" round @click="onSubmit" :disabled="!isExamStarted">提交试卷</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  examPlanService,
  examAnswersService,
  examAchievementService,
} from "@/api/exams";
import Questions from "./components/Questions";
// import ResultComp from "./components/ResultComp";
import { calculateTimeDifference } from "@/utils/index";

export default {
  name: "Course",
  components: {
    Questions,
  },
  data() {
    return {
      examPlanInfo: {
        planId: undefined,
        planName: undefined,
        paperId: undefined,
        paperName: undefined,
      },

      // 考试试卷对象
      testingPaperData: [
        {
          name: "单选题",
          score: "",
          halfScore: "",
          questionType: 1,
          children: [],
        },
        {
          name: "多选题",
          score: "",
          halfScore: "",
          questionType: 2,
          children: [],
        },
        {
          name: "判断题",
          score: "",
          halfScore: "",
          questionType: 3,
          children: [],
        },
      ],
      testingQuestionsData: [],
      fileUrl: process.env.VUE_APP_FILE_URL,
      selectedQuestionId: undefined,

      // 是否开始考试
      isExamStarted: false,
      startDate: undefined, // 考试开始时间

      //countdown: Date.now() + 1000 * 60 * 60 * 3,
      currentSystemDate: undefined, //系统返回时间
      currentSystemDateText: undefined,
      stop: false, //
      countdown: 0,
      zoom: 0, //

      msgSecond: 10,
      timerClose: null,
    };
  },
  watch: {
    // 监听路由对象中的变化
    $route: {
      handler: function () {
        //const id = this.$route.params && this.$route.params.id;
        const hash = this.$route.hash;
        if (hash.indexOf("#") !== -1) {
          let qId = hash.split("#")[1];
          this.selectedQuestionId = qId;
        }
      },
      // 设置为深度监听
      deep: true,
    },
  },
  created() {
    const id = this.$route.params && this.$route.params.id;
    this.getExamPlan(id);

    // 方式1 保存外部vue对象
    // var _this = this;
    // document.addEventListener("visibilitychange", function () {
    //   if (document.visibilityState == "hidden") {
    //     console.log("离开");
    //     // alert('警告！你已经离开当前答题页面');
    //   } else if (document.visibilityState == "visible") {
    //     console.log("回来");
    //     _this.handle();
    //   }
    // });
    // // 方式2 箭头函数形式
    // document.addEventListener("visibilitychange", () => {
    //   if (document.visibilityState == "hidden") {
    //     console.log("离开");
    //   } else {
    //     console.log("回来");
    //     this.handle();
    //   }
    // });
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisiable);
  },
  destroyed() {
    document.removeEventListener("visibilitychange", this.handleVisiable);
    // 清除定时器
    if (this.timerClose) {
      clearInterval(this.timerClose);
    }
  },
  methods: {
    // 获取考试试卷
    getExamPlan(id) {
      const loading = this.$loading({
        lock: true,
        text: "考卷加载中",
        spinner: "el-icon-loading",
      });

      examPlanService
        .getTestingById(id)
        .then((res) => {
          //console.log(res);

          this.startDate = res.startDate;

          const systemDate = new Date(res.currentSystemDate);
          // const currentDate = new Date();

          this.currentSystemDate = systemDate;
          //更新时间
          setInterval(this.updateSystemDate, 1000);

          const planStartDate = new Date(res.startDate);
          const planEndDate = new Date(res.endDate);
          if (systemDate >= planEndDate) {
            this.isExamStarted = false;
            this.stop = true;
          }
          else if (systemDate >= planStartDate) {
            this.isExamStarted = true;
            this.calculateRemainingTime(res.currentSystemDate, res.endDate);
          }
          else {
            let diffSeconds = 0;
            if (systemDate > planStartDate) {
              const diff = calculateTimeDifference(planStartDate, systemDate);
              diffSeconds = diff.seconds + 60 * diff.minutes + 60 * 60 * diff.hours;
            } else {
              const diff = calculateTimeDifference(systemDate, planStartDate);
              diffSeconds = diff.seconds + 60 * diff.minutes + 60 * 60 * diff.hours;
            }

            const timerPlanDate = setInterval(() => {
              if (diffSeconds === 0) {
                this.isExamStarted = true;
                this.calculateRemainingTime(res.startDate, res.endDate);
                clearInterval(timerPlanDate);
              }
              diffSeconds--;
            }, 1000);
          }

          // this.calculateRemainingTime(res.startDate, res.endDate);

          // if (systemDate > currentDate) {
          //   const diff = calculateTimeDifference(currentDate, systemDate);

          //   this.countdown =
          //     new Date(res.endDate).getTime() -
          //     (1000 * diff.seconds +
          //       1000 * 60 * diff.minutes +
          //       1000 * 60 * 60 * diff.hours);
          // } else {
          //   const diff = calculateTimeDifference(systemDate, currentDate);

          //   this.countdown =
          //     new Date(res.endDate).getTime() +
          //     (1000 * diff.seconds +
          //       1000 * 60 * diff.minutes +
          //       1000 * 60 * 60 * diff.hours);
          // }

          // //this.countdown = new Date(res.endDate).getTime()
          // //this.countdown = Date.now() + 1000 * 10,
          // this.stop = true;

          this.examPlanInfo = Object.assign({
            planId: res.id,
            planName: res.name,
            paperId: res.paperId,
            paperName: res.paperName,
          });

          // 试卷数据
          this.testingPaperData.forEach((paper) => {
            const setting = res.settings.find(
              (i) => i.questionType === paper.questionType
            );
            paper.score = setting.score;
            paper.halfScore = setting.halfScore;
            // paper.children = res.questions
            //   .filter((d) => d.questionType === paper.questionType)
            //   .map((question) => {
            //     return {
            //       id: question.questionId,
            //       questionType: question.questionType,
            //       topic: question.topic,
            //       options: question.options,
            //       score: question.score,
            //       checked: true,
            //     };
            //   });
            paper.children = setting.children;
          });

          const questionsData = res.questions.map((i) => {
            let options = [];
            switch (i.questionType) {
              case 3:
                options = [{ value: "对" }, { value: "错" }];
                break;
              default:
                options = i.options.map((opt) => {
                  return {
                    value: opt,
                  };
                });
                break;
            }

            return Object.assign(i, { options });
          });
          this.testingQuestionsData = questionsData;

          // 关闭遮罩层
          loading.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 计算剩余时间
    calculateRemainingTime(startDate, endDate) {
      const diff = calculateTimeDifference(new Date(startDate), new Date(endDate));
      this.countdown = Date.now() + (1000 * diff.seconds + 1000 * 60 * diff.minutes + 1000 * 60 * 60 * diff.hours);
      this.stop = true;
    },
    updateSystemDate() {
      const now = this.currentSystemDate;
      now.setSeconds(now.getSeconds() + 1);
      this.currentSystemDateText = now.toLocaleTimeString();
    },
    // 选中答题卡选项
    selectQuestion(id) {
      this.$refs.questionsChild.scrollToAnchor(id);
    },
    // 试题选中试题事件
    handleQuestionEvent(data) {
      const question = data.question;
      const children = this.testingPaperData.find(
        (i) => i.questionType === question.questionType
      )?.children;
      // 赋值答题卡
      if (children) {
        // let selecteds = [];
        // switch (question.questionType) {
        //   case 2:
        //     selecteds = question.selecteds;
        //     break;
        //   default:
        //     selecteds[0] = question.selecteds;
        //     break;
        // }
        const questionData = children.find((i) => i.id === question.id);
        questionData.selecteds = question.selecteds;

        examAnswersService
          .saveAnswers({
            planId: this.$route.params && this.$route.params.id,
            questionId: question.id,
            answer: question.selecteds,
          })
          .then(() => { });
      }
    },
    toZoom(type) {
      switch (type) {
        case "+":
          if (this.zoom < 100) {
            this.zoom += 10;
          }
          break;
        case "-":
          if (this.zoom > 0) {
            this.zoom -= 10;
          }
          break;
      }
    },
    // 系统提交
    systemSubmit() {
      this.$notify({
        title: "提示",
        message: "考试时间已到",
        duration: 0,
      });
      this.onSubmitExam(2);
    },
    //提交
    onSubmit() {
      this.$confirm(
        "提交成功后将会离开该页面, 并不能再次进入, 是否继续提交?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // 手动提交
          this.onSubmitExam(1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交",
          });
        });
    },
    onSubmitExam(type) {
      // const answersData = [].concat(
      //   ...this.testingPaperData.map((i) =>
      //     i.children.map((child) => {
      //       return {
      //         planId: this.$route.params && this.$route.params.id,
      //         questionId: child.id,
      //         answer: child.selecteds,
      //       };
      //     })
      //   )
      // );

      const achievementData = Object.assign(
        {
          classesId: this.$store.getters["user/classesId"],
          submitType: type,
          isPublicly: false, //不公开
          state: 1,
          examState: 1,
        },
        this.examPlanInfo
      );
      examAchievementService.createAchievement(achievementData).then(() => {
        // 弹框提示
        const h = this.$createElement;
        this.$msgbox({
          title: "消息",
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          // message: h(ResultComp),
          message: h("div", null, [
            h(
              "ElResult",
              {
                props: {
                  icon: "success",
                  title: "成功提示",
                  subTitle: `提交考卷成功, 页面将在${this.msgSecond}秒后自动关闭！`,
                },
              },
              ""
            ),
            h("div", { style: "text-align: center" }, [
              h(
                "spam",
                { attrs: { id: "second1" }, style: "color: teal" },
                `${this.msgSecond}秒后自动关闭`
              ),
            ]),
          ]),
          confirmButtonText: "立刻关闭",
        }).then(() => {
          window.close();
        });

        // 创建定时器
        this.timerClose = setInterval(() => {
          if (this.msgSecond === 1) {
            window.close();
          }
          this.$nextTick(() => {
            this.msgSecond = this.msgSecond - 1;
            document.getElementById(
              "second1"
            ).innerHTML = `${this.msgSecond}秒后自动关闭`;
          });
        }, 1000);
      });
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        // case "prerender":
        //   console.log("网页预渲染，内容不可见");
        //   break;
        case "hidden":
          //console.log("内容不可见，处理后台、最小化、锁屏状态");
          //alert("警告！你已经离开当前答题页面");
          this.$alert(
            '<strong style="font-size: 20px;color: #e6a23c;"><i type="warning" class="el-icon-warning-outline" style="font-size: 20px;color: #e6a23c;padding-right: 5px;"></i>警告！你已经离开当前答题页面</strong>',
            "警告",
            {
              dangerouslyUseHTMLString: true,
            }
          );
          break;
        case "visible":
          //console.log("处于正常打开");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-statistic ::v-deep .con {
  color: red;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 68px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  z-index: 4;
  border-top: 1px solid #f3f5f6;
  box-sizing: border-box;
  transition: top 0.3s 0.3s;
  -moz-transition: top 0.3s 0.3s;
  -webkit-transition: top 0.3s 0.3s;
  -o-transition: top 0.3s 0.3s;
}

.sub-header .fixed {
  position: fixed;
  top: 0;
}

.left-back {
  position: absolute;
  left: 0;
  top: 0;
  width: 236px;
  /* padding: 16px 20px; */
  box-sizing: border-box;
  transition: left 0.3s;
  -moz-transition: left 0.3s;
  -webkit-transition: left 0.3s;
  -o-transition: left 0.3s;
}

.left-back a.icon {
  display: inline-block;
  width: 28px;
  height: 28px;
  margin-right: 16px;
  vertical-align: middle;
}

.left-back a i {
  font-size: 28px;
  color: #9199a1;
  text-align: center;
  line-height: 28px;
}

.left-back span {
  font-size: 26px;
  color: #1c1f21;
  font-weight: 600;
  display: inline-block;
  /* height: 28px; */
  line-height: 36px;
  vertical-align: middle;
}

.right-title {
  margin-left: 236px;
  padding: 20px 24px;
  font-size: 14px;
  color: #9199a1;
  position: relative;
  padding-left: 68px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  transition: margin-left 0.3s;
  -moz-transition: margin-left 0.3s;
  -webkit-transition: margin-left 0.3s;
  -o-transition: margin-left 0.3s;
}

.right-title em {
  padding: 0 4px;
}

.right-title span {
  line-height: 28px;
  font-size: 18px;
  color: #1c1f21;
}

.main-con {}

.main-con .left-menu {
  position: absolute;
  top: 68px;
  left: 0;
  bottom: 0;
  width: 238px;
  z-index: 3;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  /* border: 1px solid #efefef;*/
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
}

.left-menu .catalog-con {
  position: absolute;
  width: 238px;
  top: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  padding-top: 58px;
  padding-bottom: 58px;
  box-sizing: border-box;
}

.catalog-con .inner {
  position: relative;
  height: 100%;
  width: 100%;
}

.catalog-con .inner .title {
  position: absolute;
  top: -58px;
  left: 0;
  right: 0;
  font-size: 18px;
  color: #1c1f21;
  line-height: 25px;
  margin: 0 10px;
  padding: 16px 6px;
  border-bottom: 1px solid #f3f5f6;
}

.catalog-con .inner .bottom {
  position: absolute;
  /* top: 0; */
  left: 0;
  right: 0;
  font-size: 14px;
  color: #606266;
  line-height: 10px;
  margin: 0 10px;
  padding: 14px 20px;
  border-top: 1px solid #f3f5f6;
  display: flex;
  justify-content: flex-end;
}

.catalog-con .inner .item-box {
  padding: 5px 10px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.active-bg {
  background: #f0f8ff;
}

.item {
  padding: 10px 0;
}

.item:not(:last-child) {
  border-bottom: 1px solid #dedede;
}

.item .section {
  width: 100%;
}

// 选中
.item .active {
  // background: #c0c4cc;
  filter: drop-shadow(0px 0px 2px #409eff);
}

.item .answered {
  background: #409eff;

  ::v-deep .articleName {
    color: #fff;
  }
}

.section .sec_name {
  width: 100%;
  font-size: 15px;
  color: #1c1f21;
  line-height: 18px;
  text-align: left;
  font-weight: 700;
  padding: 10px 6px;
}

ol,
ul {
  list-style: none;
}

.item ul li {
  position: relative;
  box-sizing: border-box;
  /* padding: 8px 8px; */
  margin: 5px;
  border: 1px solid rgba(28, 31, 33, 0.1);
  background: #efefef;
  width: 30px;
  height: 20px;

  text-align: center;
  cursor: pointer;
}

.item ul li .articleName {
  max-width: 380px;
  font-size: 15px;
  color: #909399;
  line-height: 20px;
  // margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.main-con .right-content {
  padding-left: 236px;
  padding-right: 200px;
  position: relative;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.right-content .container {
  /* width: 1000px; */
  margin: 0 auto;
  /* display: none; */
}

.right-content .container .center_con {
  /* width: 1000px; */
  margin-top: 52px;
  margin-bottom: 36px;
}

.container .center_con .article-con {
  padding: 52px 64px 68px;
  background: #fff;
  position: relative;
}

.right-toolbar {
  width: 150px;
  background: rgb(255, 255, 255);
  margin-left: 50px;
  right: 90px;
  top: 113px;
  position: fixed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.art-buy {
  position: absolute;
  left: 0;
  top: 0;
  /* width: 952px; */
  min-width: calc(100% - 48px);
  height: 132px;
  box-sizing: border-box;
  padding: 0 32px;
  padding: 0 8px;
  margin: 0 24px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.l {
  float: left;
}

.art-buy .img {
  /* width: 96px; */
  height: 128px;
  margin-top: -20px;
  margin-right: 19px;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 8px 0 rgba(28, 31, 33, 0.06),
    0 8px 16px 0 rgba(28, 31, 33, 0.06), 0 12px 24px 0 rgba(28, 31, 33, 0.06),
    0 16px 32px 0 rgba(28, 31, 33, 0.06);
  border-radius: 8px;
}

.art-buy .text {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
}

.art-buy .text .title {
  /* width: 348px; */
  font-weight: 700;
  font-size: 20px;
  color: #1c1f21;
  line-height: 22px;
  text-align: left;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.art-buy .text .price_con .price_ori {
  font-weight: 700;
  font-size: 12px;
  color: #9199a1;
  text-align: left;
  line-height: 12px;
  margin-right: 8px;
}

.article-con .art-title {
  font-size: 28px;
  color: #1c1f21;
  text-align: left;
  line-height: 36px;
  font-weight: 700;
  margin-bottom: 16px;

  margin-top: 112px;
}

.art-info {
  margin-bottom: 8px;
}

.art-info span {
  font-size: 12px;
  color: #9199a1;
  line-height: 24px;
}

.art-content {
  margin-bottom: 24px;
  line-height: 32px !important;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, STHeiti,
    "Microsoft Yahei", sans-serif;
  font-size: 16px;
  line-height: 32px;
  color: #1c1f21;
  word-wrap: break-word;
}

@media only screen and (max-width: 1800px) {
  .right-toolbar {
    right: 1px;
  }
}

@media only screen and (max-width: 1300px) {
  .center_con {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .right-toolbar {
    top: 69px;
  }

  .article-con {
    // padding-left: 15px !important;
    // padding-right: 15px !important;
    // padding-top: 10px !important;
    padding: 10px 15px !important;
  }
}
</style>
